import { Route, Router, Routes, useLocation } from "react-router-dom";
import "./App.css";
import Home from "./pages/Home";
import Navbar from "./components/Navbar";
import Admission from "./pages/Admission";
import Footer from "./components/Footer";
import Heartbeat from "./pages/Heartbeat";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ProtectedRoute from "./ProtectedRoute";
import TermsCondition from "./pages/TermsAndCondition";
import ShippingPolicy from "./pages/Shipping";
import Privacy from "./pages/Privacy";
import CancellationPolicys from "./pages/CancelltionPolicy";
import ContactUs from "./pages/ContactUs";
import AboutUs from "./pages/AboutUs";
import PaymentSuccess from "./pages/PaymentSuccess";
import { Helmet, HelmetProvider } from "react-helmet-async";

function App() {
  return (
    <HelmetProvider>
      <SEOHandler />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route
          path="/admission-form"
          element={
            <ProtectedRoute>
              <Admission />
            </ProtectedRoute>
          }
        />
        <Route path="/heartbeat" element={<Heartbeat />} />
        <Route path="/terms-condition" element={<TermsCondition />} />
        <Route path="/privacy-policy" element={<Privacy />} />
        <Route path="/shipping-policy" element={<ShippingPolicy />} />
        <Route path="/cancellation-policy" element={<CancellationPolicys />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route
          path="/payment-success"
          element={
            <ProtectedRoute>
              <PaymentSuccess />
            </ProtectedRoute>
          }
        />
      </Routes>
      <ToastContainer />
      <Footer />
    </HelmetProvider>
  );
}

// SEO Handler.

const SEOHandler = () => {
  const location = useLocation();

  const seoData = {
    "/": {
      title:
        "BE/B.Tech, ME/MBA Admission 2025 -Sri Ramanujar Engineering College",
      description:
        "BE/B.Tech & ME/MBA Admission 2025 at Sri Ramanujar Engineering College, Chennai. UG & PG online admissions open now. Join the best engineering college today!",
    },

    "/about-us": {
      title: "About Us -Sri Ramanujar Engineering College",
      description:
        "Learn about Sri Ramanujar Engineering College, Chennai – a premier institution offering quality education in engineering & management. Explore our vision & mission!",
    },

    "/terms-condition": {
      title: "Terms Condition -Sri Ramanujar Engineering College",
      description:
        "Apply for BE/B.Tech & ME/MBA Admission 2025 at Sri Ramanujar Engineering College. UG & PG online admissions open now. Secure your future with quality education!",
    },

    "/privacy-policy": {
      title: "Privacy Policy -Sri Ramanujar Engineering College",
      description:
        "Read the Privacy Policy of Sri Ramanujar Engineering College. Learn how we collect, use, and protect your information to ensure a secure online experience.",
    },

    "/contact-us": {
      title: "Contact us -Sri Ramanujar Engineering College",
      description:
        "Contact Sri Ramanujar Engineering College, Chennai for admissions, courses, and inquiries. Get in touch with us for assistance and information.",
    },

    "/shipping-policy": {
      title: "Shipping Policy -Sri Ramanujar Engineering College",
      description:
        " Read the Shipping Policy of Sri Ramanujar Engineering College. Learn about our delivery process, timelines, and terms for seamless service and support. ",
    },

    "/cancellation-policy": {
      title: "Cancellation Policy -Sri Ramanujar Engineering College",
      description:
        "Read the Cancellation Policy of Sri Ramanujar Engineering College, Chennai. Learn about our terms and conditions for cancellations and refunds.",
    },
  };

  const { title, description } = seoData[location.pathname] || {
    title:
      "BE/B.Tech, ME/MBA Admission 2025 -Sri Ramanujar Engineering College",
    description:
      "BE/B.Tech & ME/MBA Admission 2025 at Sri Ramanujar Engineering College, Chennai. UG & PG online admissions open now. Join the best engineering college today!",
  };

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
    </Helmet>
  );
};

export default App;
